import { useAuth } from '@chainlit/react-client';

import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/components/i18n/Translator';
import UpgradeDashboard from '@/components/dashboard/UpgradeDashboard';

export default function Subscribe() {
  const { logout } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="min-h-svh flex flex-col">
      <div className="flex items-center justify-between p-6 md:p-10 pb-0">
        <Logo className="w-[150px]" />
        <Button variant="ghost" onClick={() => logout(true)}>
          {t('navigation.user.menu.logout')}
        </Button>
      </div>
      <div className="flex-1 flex justify-center p-6 md:p-10">
        <div className="w-full max-w-3xl">
          <UpgradeDashboard />
        </div>
      </div>
    </div>
  );
}
